export default __webpack_public_path__ + "static/media/roundTrip.2e9426b4.svg";